import React from "react";
import "../../Components/globalVariables.js";

const PrivacyPolicy = () => {
  return (
    <div style={{ width: "100%", height: "100vh", background: "#fff" }}>
      <iframe
        src={global.privacy_policy_viewer}
        title="Privacy Policy"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default PrivacyPolicy;